/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthcareServiceModel } from '../../models/healthcare-service-model';

export interface AdminFhirIdHealthcareServicePost$Params {
  fhirId: string;
      body?: HealthcareServiceModel
}

export function adminFhirIdHealthcareServicePost(http: HttpClient, rootUrl: string, params: AdminFhirIdHealthcareServicePost$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdHealthcareServicePost.PATH, 'post');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<string>;
    })
  );
}

adminFhirIdHealthcareServicePost.PATH = '/Admin/{fhirId}/HealthcareService';
